import { db } from '@/shared/services/firebase'

const getAccountById = accountId => new Promise((resolve, reject) => {
  db.collection('accounts')
    .doc(accountId)
    .get()
    .then(doc => {
      if (doc.exists) {
        const item = doc.data()
        item.id = doc.id
        resolve(item)
      }
    })
    .catch(error => {
      reject(error)
    })
})

export {
  // eslint-disable-next-line import/prefer-default-export
  getAccountById,
}
